(function(){
  'use strict';
  angular.module("irricrops")
    .directive('colorIcon', [ '$timeout', function($timeout) {
      return {
        restrict: 'E',
        transclude: true,
        scope: {
          max        : '=',
          min        : '=',
          num        : '=',
          classNames : '=',
        },
        templateUrl: 'shared/colorIcon/colorIcon.tmpl.html',
        controller : ['$scope', function($scope){

          $scope.actualClass = "empty";

           var calculateClass = function(){
             if(!_.isNaN($scope.num)){
               if($scope.num >= $scope.max){
                 $scope.actualClass = $scope.classNames[0]
               }
               else if($scope.num >= $scope.min){
                 $scope.actualClass = $scope.classNames[1]
               } else {
                 $scope.actualClass = $scope.classNames[2]
               }
             }
           }

           $scope.$watch($scope.num, calculateClass);
           calculateClass();

        }]
      };
    }]);
})();
